import AppErrorsAlert from '@molecules/Alerts/AppErrorsAlert'

import TagsFieldRow from './TagsFieldRow'
type TagsFormProps = {
  supporterId: string
  groupId?: string
  updateTags: boolean
  tags: Array<{ value: string; label: string }>
}

export default function TagsForm({ groupId, supporterId, updateTags, tags }: TagsFormProps) {
  return (
    <>
      <AppErrorsAlert errorsPath="supporterTags" />

      <TagsFieldRow groupId={groupId} supporterId={supporterId} canEdit={updateTags} tags={tags} />
    </>
  )
}
